import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '../i18n';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const business = process.env.REACT_APP_SITE_NAME;
  const domain = process.env.REACT_APP_DOMAIN;
  const email = process.env.REACT_APP_EMAIL;
  const businessName = process.env.REACT_APP_BUSINESS_NAME;
  const cnpj = process.env.REACT_APP_CNPJ;
  const businessAddress = process.env.REACT_APP_STREET;
  const neighborhood = process.env.REACT_APP_NEIGHBORHOOD;
  const city = process.env.REACT_APP_CITY;
  const state = process.env.REACT_APP_STATE;

  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.5 }}
    >
      <div className="footer-content">
        <div className="footer-section">
          <h4>{t('footer.about')}</h4>
          <p>{business} - {t('footer.tagline')}</p>
          <p className="footer-domain">{domain}</p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.legal')}</h4>
          <nav className="footer-links">
            <Link to="/termos">{t('footer.termsOfUse')}</Link>
            <Link to="/politicas">{t('footer.privacyPolicy')}</Link>
          </nav>
        </div>

        <div className="footer-section">
          <h4>{t('footer.contact')}</h4>
          <p>{email}</p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.company')}</h4>
          <p className="company-info">{businessName}</p>
          <p className="company-info">RUC: {cnpj}</p>
          <p className="company-info">{t('footer.address', { address: businessAddress, neighborhood, city, state })}</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} {business}. {t('common.allRightsReserved')}</p>
        <p className="footer-company">{businessName}</p>
      </div>
    </motion.footer>
  );
};

export default Footer;
